import styled from 'styled-components'
import { Typography, Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Header = styled.h3`
  ${Typography.sizes.Caps};
  font-weight: ${Typography.weights.demibold};
  color: ${Colors.Neutral50};

  ${Media.Phone`
    text-align: center;
  `}
`

export const Mark = styled.div`
  height: 16px;
  width: 3px;
  background-color: ${Colors.Neutral15};
`
